import { render, staticRenderFns } from "./step-exterior-color.vue?vue&type=template&id=3af4029c"
import script from "./step-exterior-color.vue?vue&type=script&lang=ts"
export * from "./step-exterior-color.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports